import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router";
import { Outlet } from "react-router-dom";
import { Home } from "src/pages/dashboard/index";
import { Layout as DashboardLayout } from "src/layouts/dashboard";
import Onboarding from "src/pages/auth/jwt/onboarding";
import { Layout as ClassicLayout } from "src/layouts/auth/classic-layout";
import { UserDataContexType } from "src/contexts/userData-context";
import { UserDataContext } from "src/contexts/userData-context";
import { UserDataProvider } from "src/contexts/userData-context";
import { HouseholdProvider } from "src/contexts/household-context";

const LegalPage = lazy(() => import("src/pages/dashboard/legal"));
const FinancialPage = lazy(() => import("src/pages/dashboard/financial"));
const PersonalPage = lazy(() => import("src/pages/dashboard/personal"));
const DigitalPage = lazy(() => import("src/pages/dashboard/digital"));
const PropertyPage = lazy(() => import("src/pages/dashboard/property"));
const LegacyPage = lazy(() => import("src/pages/dashboard/legacy"));
const MedicalPage = lazy(() => import("src/pages/dashboard/medical"));

const WillsAndTrustsHome = lazy(
  () => import("src/pages/dashboard/documents/wills-and-trusts/index")
);
const WillsAndTrustsCreate = lazy(
  () => import("src/pages/dashboard/documents/wills-and-trusts/create")
);
const PowerOfAttorneyHome = lazy(
  () => import("src/pages/dashboard/documents/power-of-attorney/index")
);
const PowerOfAttorneyCreate = lazy(
  () => import("src/pages/dashboard/documents/power-of-attorney/create")
);
const HealthCareDirectiveHome = lazy(
  () => import("src/pages/dashboard/documents/health-care-directive/index")
);
const HealthCareDirectiveCreate = lazy(
  () => import("src/pages/dashboard/documents/health-care-directive/create")
);

// Other
const AccountPage = lazy(() => import("src/pages/dashboard/account"));

export const dashboardRoutes: RouteObject[] = [
  {
    path: "",
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        path: "/",
        element: <Home />,
      },
      {
        path: "account/:tab?",
        element: <AccountPage />,
      },
      {
        path: ":ud_id/legal",
        element: <LegalPage />,
      },
      {
        path: ":ud_id/medical",
        element: <MedicalPage />,
      },
      {
        path: ":ud_id/legacy",
        element: <LegacyPage />,
      },
      {
        path: ":ud_id/financial",
        element: <FinancialPage />,
      },
      {
        path: ":ud_id/property",
        element: <PropertyPage />,
      },
      {
        path: ":ud_id/financial",
        element: <FinancialPage />,
      },
      {
        path: ":ud_id/personal",
        element: <PersonalPage />,
      },
      {
        path: ":ud_id/digital",
        element: <DigitalPage />,
      },
      {
        path: ":ud_id/wills-and-trusts",
        element: <WillsAndTrustsHome />,
      },
      {
        path: ":ud_id/financial-power-of-attorney",
        element: <PowerOfAttorneyHome />,
      },
      {
        path: ":ud_id/health-care-directive",
        element: <HealthCareDirectiveHome />,
      },
      {
        path: ":ud_id/wills-and-trusts/create/:estateDocId",
        element: <WillsAndTrustsCreate />,
      },
      {
        path: ":ud_id/financial-power-of-attorney/create/:estateDocId",
        element: <PowerOfAttorneyCreate />,
      },
      {
        path: ":ud_id/health-care-directive/create/:estateDocId",
        element: <HealthCareDirectiveCreate />,
      },

    ],

  }, {
    path: "onboarding",
    element: <UserDataProvider>
      <UserDataContext.Consumer>
        {(userDataContext: UserDataContexType) => {
          return (
            <HouseholdProvider userData={userDataContext.userData || null} ownerUserData={userDataContext.ownerUserData || null} updateProHouseholdContext={userDataContext.updateProHouseholdContext || null}>
              <ClassicLayout>
                <Suspense>
                  <Onboarding />
                </Suspense>
              </ClassicLayout>
            </HouseholdProvider>
          );
        }}
      </UserDataContext.Consumer>
    </UserDataProvider>,
  },

];

